import { ratingQuestionTemplate } from "./utils";
import { loc } from "../i18n/survey";

const dietQuestion = {
  ...ratingQuestionTemplate,
  name: 'diet',
  title: loc("quiz.rating.title"),
  description: loc("quiz.diet.statement"),
};

export {
  dietQuestion,
}